import clientTypeHandler from "../../services/ClientType";
import clientsHandler from "@/services/Clients";

export default {
    async loadClientTypes({commit, dispatch}, payload) {
        const {data} = await clientTypeHandler.all(payload);

        commit('SET_CLIENT_TYPES', data);
    },
    async loadClientTypesList({commit, dispatch}, payload) {
        const {data} = await clientTypeHandler.list(payload);

        commit('SET_CLIENT_TYPES', data);
    },
    async storeClientType({commit, dispatch}, payload) {
        return clientTypeHandler.store(payload);
    },
    async updateClientType({commit, dispatch}, payload) {
        return clientTypeHandler.update(payload);
    },
    async destroyClientType({commit, dispatch}, payload) {
        return clientTypeHandler.destroy(payload);
    },
}
